module.exports = __webpack_public_path__ + "img/fire-third.0321cfe8.svg";